import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { currentTheme, isLargeScreen } from '../../global.variable';
import { AppService } from '../app.service';
import { JobsService } from '../pages/pages/jobs/jobs.service';
import { UserProfileService } from '../profile/user-profile/user-profile.service';
import { AppChecksComponent } from '../shared/components/app-checks/app-checks.component';
import { ModalDialogueService } from '../shared/components/modal-dialogue/modal-dialogue.service';
import { SplashScreenComponent } from '../shared/components/splash-screen/splash-screen.component';
import { DataCheckService } from '../shared/services/data-check.service';
import { DeviceInfoService } from '../shared/services/device-info.service';
import { LoadingSpinnerService } from '../shared/services/loading-spinner.service';
import { OrientationLockService } from '../shared/services/orientationlock.service';
import { ToasterService } from '../shared/services/toaster.service';

declare var bootstrap: any;
declare var GuideChimp: any;

@Component({
  selector: 'gtapp-prime-contractor',
  standalone: false,
  templateUrl: './prime-contractor.component.html',
  styleUrl: './prime-contractor.component.scss',
})
export class PrimeContractorComponent implements OnInit, OnDestroy {
  isSuperUserAccess = localStorage.getItem(btoa('superUserAccess')) === 'true';

  currentTheme: any = currentTheme;
  largeView: Boolean = isLargeScreen;
  isAppOnline: boolean = true;

  permissionErrorStatus: any;

  isSubscriptionActive = this.dataCheckService.checkIsSubscriptionOrTestUser();

  minSupportVersionDevice: any;
  appNewVersionAvailable: boolean = false;

  internetConnectionAvailable: boolean = navigator.onLine;
  offlineMode: boolean = false;

  isHomeComponent: boolean = false;
  currentRoute: string = '';

  windowScrolled = false;

  subscriberStats: any;

  faqItemDict: any = {};
  existingSupportQueries: boolean = false;
  userCurrentDeviceDetail: any = {};

  feedbackForm = new FormGroup({
    feedback: new FormControl('', [
      Validators.required,
      Validators.maxLength(340),
    ]),
  });

  splashScreenOpened: boolean = false;
  isPhoneIOS = this.deviceInfoService.isPhoneIOS();

  constructor(
    private orientationLockService: OrientationLockService,
    private spinnerService: LoadingSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
    private profileService: UserProfileService,
    private dialogService: ModalDialogueService,
    private dataCheckService: DataCheckService,
    private ngZone: NgZone,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private cdr: ChangeDetectorRef,
    private deviceInfoService: DeviceInfoService,
    private jobService: JobsService,
  ) {
    this.currentTheme = this.appService.getGTAppTheme();
    this.appService.switchGTAppTheme(this.currentTheme);
    this.router.events.subscribe((event: any) => {
      if (event.navigationTrigger === 'popstate') {
        // WHEN USER CLICK THE BACK BUTTON
        this.triggerCleanUp();
      }
      if (event instanceof NavigationStart) {
        // Show progress spinner or progress bar
        // this.pageService.refreshToken().then((value: any) => {
        //   if (value) this.updateLoggedInUserDetail();
        // });
      }

      if (event instanceof NavigationEnd) {
        const currentUrl = this.router.url.split('#');

        if (currentUrl?.length && currentUrl[0] != this.currentRoute) {
          this.currentRoute = currentUrl[0];
          this.triggerCleanUp();

          if (this.currentRoute !== '/delete-account') {
          }
          // this.getNotificationCount();

          window.scrollTo(0, 0);
          this.checkAndStartGuide({});
        }

        this.isHomeComponent = event.urlAfterRedirects === '/pc';
      }

      this.isSubscriptionActive =
        this.dataCheckService.checkIsSubscriptionOrTestUser();
    });
  }

  triggerCleanUp() {
    this.dialogService?.closeAll();

    this.appService.removeToolTips();
  }

  ngOnDestroy() {}
  async ngOnInit() {
    let scrollTimeout: any;

    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      const isScrollingUp = currentScrollY < lastScrollY;
      const showThreshold = 100;
      if ('ontouchstart' in window) {
        this.windowScrolled = isScrollingUp && currentScrollY > showThreshold;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          this.windowScrolled = false;
        }, 2000);
      }

      lastScrollY = currentScrollY;
    });

    this.deviceInfoService.deviceInfoSubject.subscribe((value: any) => {
      if ('permissionStatus' in value) {
        this.modifyAppStatus(value?.permissionStatus);
      }
      if ('appStatus' in value) {
        this.internetConnectionAvailable = navigator.onLine;
        this.checkOnlineOffline(value?.appStatus);
      }
      // if ('geoFenceAlert' in value) {
      //   this.geoFenceOutsideAlert(value?.geoFenceAlert);
      // }
      if ('appNewVersionAvailable' in value) {
        this.appNewVersionAvailable =
          sessionStorage.getItem('updateAvailable') === 'true';
      }
      // if (value?.subscriptionCheck) {
      //   this.getSideBar();
      // }
    });

    this.appService.updateGuardTrackerApp();

    // password set check
    this.userAppChecks();
  }
  openSplashScreen(firstTime = true) {
    if (this.splashScreenOpened) return;
    this.splashScreenOpened = true;

    const dialogRef = this.dialogService.open(SplashScreenComponent, {
      data: { firstTime: firstTime },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.splashScreenOpened = false;
    });
  }
  modifyAppStatus(value: string) {
    switch (value) {
      case 'locationDisabled':
        this.permissionErrorStatus = {
          icon: 'alert-triangle',
          status: 'danger',
          message: `Warning: Certain functions may not work without access to your location`,
          type: 'locationDisabled',
        };
        const isIOSUser =
          this.isPhoneIOS &&
          !this.largeView &&
          localStorage.getItem(btoa('isIOSFirstTimeUser')) === 'false';
        if (isIOSUser) this.openSplashScreen(false);
        break;
      case 'locationEnabled':
        if (this.permissionErrorStatus?.type === 'locationDisabled') {
          this.permissionErrorStatus = null;
        }

        break;
      case 'cameraDisabled':
        this.permissionErrorStatus = {
          icon: 'alert-triangle',
          status: 'danger',
          message: `Warning: Camera access not given`,
        };
        break;
      case 'notificationDisabled':
        this.permissionErrorStatus = {
          icon: 'alert-triangle',
          status: 'danger',
          message: `Warning: Permission for push notifications not given`,
        };
        break;
    }

    this.cdr.detectChanges();
    const tooltipElement = document.getElementById('customTooltipBtn');

    if (tooltipElement) {
      // Dispose of the existing tooltip instance if it exists
      const existingTooltip = bootstrap.Tooltip.getInstance(tooltipElement);
      if (existingTooltip) {
        existingTooltip.dispose();
      }

      const tooltipInstance = new bootstrap.Tooltip(tooltipElement);
      tooltipInstance.setContent({
        '.tooltip-inner': this.permissionErrorStatus?.message,
      });
      tooltipInstance?.show();
      setTimeout(() => {
        tooltipInstance?.hide();
      }, 1000);
    }
  }
  userAppChecks() {
    //check whther user has set password, first name last name etc

    if (
      this.dataCheckService.hasPasswordSet() === false ||
      window.localStorage.getItem('resetPasswordPWA')
    ) {
      const dialogRefUser = this.dialogService.open(AppChecksComponent, {
        data: {},
      });
      dialogRefUser.afterClosed().subscribe((value: any) => {
        this.spinnerService.hide();
        window.location.reload();
      });
    }
  }
  scrollToTop() {
    this.windowScrolled = false;
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
  }
  updateGuardTrackerApp() {
    if (sessionStorage.getItem('updateAvailable') === 'true') {
      this.toasterService.setMessage({
        successMessage: 'Please Wait, Updating Guard Tracker',
        errorMessage: '',
      });
      //making sure that the user is in home page and is doing nothing, to do a reload to clear the cache
      sessionStorage.removeItem('updateAvailable');
      localStorage.setItem('loginSuccess', 'true');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      this.appNewVersionAvailable = false;
    }
  }
  async checkOnlineOffline(isAppOnline: boolean = true) {
    // if the user is not on middle of the update reload the page when the device comes back online

    this.isAppOnline = isAppOnline;
    this.offlineMode = !this.isAppOnline;

    this.appService.initializeBootstrapTooltips();

    if (this.offlineMode && !this.isHomeComponent) {
      this.ngZone.run(() => {
        setTimeout(() => {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: `Unable to connect to server, operating in offline mode.`,
          });
        }, 100);

        setTimeout(() => {
          this.router.navigate(['/pc']);
        }, 3000);
      });
    }
  }

  guardTrackerIconClick(reload = false) {
    if (['/pc'].includes(this.currentRoute)) {
      if (reload) window.location.reload();

      return;
    }

    this.router.navigate(['/pc']);
  }
  goBack() {
    window.history.back();
  }
  handleWrapperClick(event: Event) {
    // Prevent the wrapper click event from interfering with child elements
    event.stopPropagation();
  }
  exitSuperUser() {
    if (!this.isSuperUserAccess) return;
    this.spinnerService.show();
    const superUserAcessData: any = localStorage.getItem(
      btoa('superUserAcessData'),
    );
    const masqueradedFrom =
      sessionStorage.getItem(btoa('masqueradedFrom')) || '/gtadmin/subscribers';

    let routePath: any = ['/gtadmin/subscribers'];
    let routeDict = {};

    try {
      const url = new URL(masqueradedFrom);
      const [basePath, matrixString] = url.pathname.split(';');

      // Parse matrix string into an object: { sKey: "8d4c81f2..." }
      const matrixParams = matrixString
        ? Object.fromEntries(matrixString.split(';').map((p) => p.split('=')))
        : {};

      routePath = [basePath, matrixParams];

      const queryParams = Object.fromEntries(url.searchParams.entries());

      const fragment = url.hash ? url.hash.substring(1) : null;
      routeDict = { queryParams, fragment: fragment || undefined };
    } catch (error) {}

    sessionStorage.clear();
    localStorage.clear();
    localStorage.setItem('userData', superUserAcessData);

    setTimeout(() => {
      this.router.navigate(routePath, routeDict).then(() => {
        window.location.reload();
        this.spinnerService.hide();
      });
    }, 500);
  }

  lockScreen() {
    this.orientationLockService.lockOrientation();
  }
  showHideDraggableFeedbackBtn(value: any) {
    if (value === true) {
      let element: any = document.getElementById('globalFeedbackbtn');
      element.style.visibility = 'hidden';
    } else {
      let element: any = document.getElementById('globalFeedbackbtn');
      element.style.visibility = 'visible';
    }
  }
  getSubscriberStats() {
    this.existingSupportQueries = false;
    this.spinnerService.show();
    let param: any = {
      time_offset: new Date().getTimezoneOffset(),
      subscriber_stats: 1,
    };

    this.jobService.getDashBoardData(param).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.subscriberStats = response?.data?.subscriber_stats;
        this.existingSupportQueries = response?.data?.support_queries;

        localStorage.setItem(
          'subscriberStats',
          JSON.stringify(response?.data?.subscriber_stats || {}),
        );
        this.spinnerService.hide();
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }
  openSupportQueryCreateTemplate(requestRef: TemplateRef<any>) {
    this.faqItemDict = {};
    this.userCurrentDeviceDetail = {
      time: new Date(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    this.getSubscriberStats();
    this.feedbackForm.controls['feedback'].setValue(null);
    this.showHideDraggableFeedbackBtn(true);
    this.deviceInfoService.getDeviceDetail().then((res: any) => {
      if (res) {
        [
          'browser_version',
          'os',
          'browser',
          'os_version',
          'deviceType',
          'device',
        ]?.forEach((key: any) => {
          if (res[key] && res[key]?.toLowerCase() !== 'unknown')
            this.userCurrentDeviceDetail[key] = res[key];
        });
        this.userCurrentDeviceDetail['gps'] = res?.gps;
      }
    });

    this.appService
      .getCurrentVersionInfo()
      .then((data: any) => sessionStorage.setItem('appVersion', data?.version));
    const dialogRef = this.dialogService.open(
      requestRef,
      {
        data: {},
      },
      this.viewContainerRef,
    );

    dialogRef?.afterClosed().subscribe(() => this.feedbackForm.reset());
  }
  clearAndFocusTextBox(elementId: string) {
    this.feedbackForm.controls['feedback'].setValue('');
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  addfeedback() {
    this.spinnerService.show();
    const feedbackValue: any = this.feedbackForm.get('feedback')?.value;
    let fileData: FormData = new FormData();

    fileData.append('feedback', feedbackValue);

    fileData.append(
      'app_version',
      String(sessionStorage.getItem('appVersion') || ''),
    );
    this.appService
      .formDataApi(`feedback/submit_feedback`, fileData)
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
          this.feedbackForm.reset();

          this.spinnerService.hide();
          this;
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }
  clearAllDataAndReload() {
    const userData = this.appService.getUserData();

    localStorage.clear();
    sessionStorage.clear();
    this.appService.setUserData(userData);
    localStorage.setItem('loginSuccess', 'true');
    this.router.navigate(['/pc']).then(() => {
      window.location.reload();
    });
  }
  getBasePath(url: string): string {
    if (url == '/') return url;
    const urlTree = this.router.parseUrl(url);
    const urlSegments = urlTree.root.children['primary'].segments;
    url = urlSegments?.length ? '/' + urlSegments[0]?.path : '/';
    return url;
  }
  checkAndStartGuide(userGuideStored: any) {
    if (!userGuideStored) {
      localStorage.removeItem('userGuide');
      return;
    }
    // case where the user needs to add password and details
    if (
      this.dataCheckService.hasPasswordSet() === false ||
      window.localStorage.getItem('resetPasswordPWA')
    )
      return;
    const baseUrl = this.getBasePath(this.router.url);
    const isIOSFirstTimeUser =
      (this.isPhoneIOS && !this.largeView && !('gtAppTheme' in localStorage)) ||
      localStorage.getItem(btoa('isIOSFirstTimeUser')) === 'true';

    if (isIOSFirstTimeUser && ['/pc'].includes(baseUrl)) {
      // https://app.shortcut.com/sendem/story/10710/add-allow-location-services-access-for-mobile-splash-page
      // we will open a dialog box here to show the splash screen, then will mark the user as not the first time user
      this.openSplashScreen();
      return;
    }
    let userGuideInBrowser = JSON.parse(
      localStorage.getItem('userGuide') || '{}',
    );
    userGuideStored = { ...userGuideInBrowser, ...(userGuideStored || {}) };

    localStorage.setItem('userGuide', JSON.stringify(userGuideStored));

    let key: any = '';

    switch (baseUrl) {
      case '/':
        // home page
        key = 'basics';
        break;
    }
    if (!key) return;

    // if (!userGuideStored?.[key]) {
    //   if (!this.onBoarding?.[key]) {
    //     this.onBoarding[key] = true;
    //     this.startGuide(key);
    //   }
    // }
  }
  signOut() {
    this.spinnerService.show('Signing Out');

    let userData = this.appService.getUserData();

    this.profileService
      .logOut({ theme: userData?.preferences?.theme })
      .then((response: any) => {
        if (response?.status === 'success') {
          this.logOut();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  logOut() {
    const userData = this.appService.getUserData();
    const gtAppTheme: any = this.appService.getGTAppTheme();
    const uniqueDeviceID = localStorage.getItem(btoa('uniqueDeviceID'));
    const isIOSFirstTimeUser =
      localStorage.getItem(btoa('isIOSFirstTimeUser')) || 'false';
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem('email', userData?.profile?.email);
    localStorage.setItem(btoa('isIOSFirstTimeUser'), isIOSFirstTimeUser);
    if (uniqueDeviceID)
      localStorage.setItem(btoa('uniqueDeviceID'), uniqueDeviceID);
    this.appService.setGTAppTheme(gtAppTheme);

    this.router.navigate(['/login']).then(() => {
      window.location.reload();
    });
  }
}
